<template>
<div class="container container-tabs">

    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>

      <div class="handle-box">


        <el-row class="head-search">
          <el-col :span="8">
            <span class="title">申请时间:</span>
            <el-date-picker v-model="time_stamp" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"
              style="width: 200px;" @change="timeChange">
            </el-date-picker>
          </el-col>
           <el-col :span="8">
                        <span class="title">订单号 : </span>
                        <el-input
                            v-model="search_data.billno"
                            placeholder=" "
                            @keyup.enter.native="searchorderInvoiceList"
                            style="width: 200px"
                        ></el-input>
                    </el-col>


          <el-col :span="8">
            <p>发票余量:{{remain.remainNum}}</p>
            <p>更新时间:{{remain.updateTime}}</p>
          </el-col>



        </el-row>




        <el-button type="primary" icon="el-icon-search" @click="searchorderInvoiceList">搜索</el-button>

        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

        <el-button v-if="excelBtn_isShow == 1" :icon="progress_show?'el-icon-loading':'el-icon-setting'" @click="toExport" :disabled="progress_show">{{progress_show?'导出中...':'导出'}}</el-button>

        <el-button type="primary" @click="batchEditOrderInvoiceSubmit('1')">批量通过</el-button>
        <el-button type="danger" @click="batchEditOrderInvoiceSubmit('2')">批量拒绝</el-button>





      </div>

    </el-tabs>
  



    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="selectionChange">


      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">

            <div class="more-style">

              <el-form-item label="订单号:">
                <span v-for="(item, index) in props.row.order_code_array" style="display: block;">{{ item }}</span>
              </el-form-item>

              <el-form-item label="是否发送邮箱:">
                <span>{{ props.row.is_push_email.alias }}</span>
              </el-form-item>

              <el-form-item label="是否邮寄:">
                <span>{{ props.row.is_mail.alias }}</span>
              </el-form-item>

            </div>


            <div class="more-style">

              <el-form-item label="所属城市:">
                <span>{{ props.row.city.name }}</span>
              </el-form-item>

              <el-form-item label="地址:">
                <span>{{ props.row.city.address?props.row.city.address:'-' }}</span>
              </el-form-item>



              <el-form-item label="银行卡号:">
                <span>{{ props.row.bank_number?props.row.bank_number:'-' }}</span>
              </el-form-item>

            </div>


          </el-form>
        </template>
      </el-table-column>



      <el-table-column
              type="selection"
              width="55">
      </el-table-column>


      <el-table-column prop="company_name" label="公司名称" width="200">

        <template slot-scope="scope">
          {{ scope.row.company_name ? scope.row.company_name : '-' }}
        </template>

      </el-table-column>


      <el-table-column prop="company_name" label="发票抬头" width="200">

        <template slot-scope="scope">
          {{ scope.row.synchronization.taxpayer_number ? scope.row.synchronization.taxpayer_number : '-' }}
        </template>

      </el-table-column>

      <el-table-column prop="address" label="地址" width="200">

        <template slot-scope="scope">
          {{ scope.row.synchronization.address ? scope.row.synchronization.address : '-' }}
        </template>

      </el-table-column>





      <el-table-column prop="company_name" label="开票状态" width="200">

        <template slot-scope="scope">
          {{ scope.row.invoice_status.alias }}
        </template>

      </el-table-column>





      <el-table-column prop="phone" label="电话" min-width="150">
      </el-table-column>


      <el-table-column prop="email" label="邮箱" min-width="200">
      </el-table-column>




      <el-table-column prop="total_money" label="金额">
      </el-table-column>


      <el-table-column label="类型" width="150">

        <template slot-scope="scope">
          <el-tag :type="scope.row.type =='1'?'warning':'success'">
            {{ scope.row.type =='1'?'个人':'企业' }}</el-tag>
        </template>

      </el-table-column>

      <el-table-column label="审核判定状态" width="150">

        <template slot-scope="scope">
          <el-tag :type="scope.row.verify_status.val =='0'?'warning':(scope.row.verify_status.val=='1'?'':'danger')">
            {{scope.row.verify_status.alias}}</el-tag>
        </template>

      </el-table-column>

      <el-table-column prop="verify_remarks" label="备注" width="200">
      </el-table-column>

      <el-table-column prop="time.YmdHis" label="申请时间" width="200">
      </el-table-column>


      <el-table-column prop="pdf_address" label="发票地址" width="200">
        <template slot-scope="scope">

          <a :href="scope.row.pdf_address" target="_blank">{{scope.row.pdf_address}}</a>
        </template>
      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button :disabled="scope.row.verify_status.val != '0'" type="primary" @click="toDetermine(scope.row.order_invoice_code,scope.row.verify_status.val)">
            发票审核

          </el-button>
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <invoiceToDetermine :data="invoiceToDetermine_data" :isShow="invoiceToDetermine_isShow"
      @onSubmit="orderInvoiceList"></invoiceToDetermine>


  </div>

</template>

<script>
  var _this;
  import invoiceToDetermine from './invoiceToDetermine.vue';
  export default {
    components: {
      invoiceToDetermine,
    },
    data() {
      return {

        activeName: 'all',

        excelBtn_isShow:JSON.parse(localStorage.getItem('login')).export_order_invoice,

        time_stamp:'',

        // 抽屉开关按钮
        invoiceToDetermine_isShow: false,

        progress_show:false,

        remain:{
          remainNum:'0',
          updateTime:''
        },

        excelData: [],

        excelHead: [],

        // 传入子组件的数据
        invoiceToDetermine_data: '',


        // 详细搜索
        more_search: false,

        delDriverSubmit_rules: {
          driver_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },


        // 下拉搜索管理状态
        value_status_code: '',
        value_status_array: '',

        order_code_array:'',

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          time_stamp: '',
          verify_status: '',
          billno: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.orderInvoiceList();

    },

    methods: {
      timeChange(val){
        console.log(val);
        if(val !=null){
          _this.search_data.time_stamp = val
        }else {
          _this.search_data.time_stamp = ''
        }
      },

      batchEditOrderInvoiceSubmit(status){

        _this.$post(
                "/order/batchEditOrderInvoiceSubmit",
                {
                  order_invoice_code:_this.order_code_array,
                  verify_status:status
                }
        )
                .then(res => {

                  _this.$message.success('处理完成')

                }).catch((err) => {

        })

      },

      selectionChange(val){
        console.log(val);

        let chengeArray = []

        for (let i=0;i<val.length;i++){
          chengeArray.push(val[i].order_invoice_code)
        }
        _this.order_code_array = JSON.stringify(chengeArray)

        console.log(_this.order_code_array);

      },
      toExport() {

        _this.search_data.page = 1;
        _this.getExcelData();

      },

      getExcelData() {

        _this.$post(
                "/order/exportOrderInvoiceListCSV",{
                  page:_this.search_data.page,
                  time_stamp:_this.search_data.time_stamp,
                  verify_status:_this.search_data.verify_status,
                }

        ).then(res => {

          _this.progress_show = true;

          if (this.$route.path == '/orderInvoice') {

            console.log(res.data);
            // 导出excel的空数组中添加数据
            for (let i = 0; i < res.data.result.length; i++) {

              _this.excelData.push({
                'company_name': res.data.result[i].company_name,
                'taxpayer_number': res.data.result[i].taxpayer_number,
                'bank_deposit': res.data.result[i].bank_deposit,
                'id_card': res.data.result[i].id_card,
                'phone': res.data.result[i].phone,
                'email': res.data.result[i].email,
                'total_money': res.data.result[i].total_money,
                'type': res.data.result[i].type =='1' ? '个人':'企业',
                'verify_status':res.data.result[i].verify_status.alias,
                'time': res.data.result[i].time.YmdHis,

              });


            }



            if (res.data.page * res.data.limit < res.data.count) {

              _this.search_data.page = res.data.page + 1;

              // _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

              _this.getExcelData();

            } else {

              console.log(_this.excelData);

              // 将数据导出execl
              _this.exportData();

              _this.search_data.page = 1;

              // 清空数据
              _this.excelData = [];

              _this.progress_show = false;


            }

          } else {

            _this.progress_show = false;

          }



        }).catch((err) => {

        })

      },

      // 导出excel方法
      exportData() {
        const {
          export_json_to_excel
        } = require('@/vendor/Export2Excel');
        const tHeader = ['名称', '发票抬头', '开户行', '身份证号', '电话', '邮箱', '金额','类型','审核判定状态','时间'];
        const filterVal = ['company_name', 'taxpayer_number','bank_deposit', 'id_card', 'phone', 'email', 'total_money', 'type', 'verify_status','time'];
        const list = this.excelData;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, 'fileName');
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },



      // 发票审核(code,审核状态)
      toDetermine(code, val) {
        if (val != 1) {

          _this.invoiceToDetermine_isShow = !_this.invoiceToDetermine_isShow;
          _this.invoiceToDetermine_data = code;

        }else{

          _this.$message.error('该条数据已经审核通过,请勿重复审核')

        }

      },




      searchorderInvoiceList() {
        _this.search_data.page = 1;
        _this.orderInvoiceList();
      },


      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.verify_status = tab.name;
        } else {
          _this.search_data.verify_status = '';
        }
        _this.search_data.page = 1;
        _this.orderInvoiceList();

      },


      // 搜索列表
      orderInvoiceList() {
        _this.$post(
            "/order/orderInvoiceList",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.value_status_array = _this.tableData[0].verify_status.select_array;
          }).catch((err) => {

          })


        _this.$post(
          "/order/getInvoiceSum",
          {
            order_invoice_code:_this.order_code_array,
            verify_status:status
          }
        )
          .then(res => {

            _this.remain= res.data

          }).catch((err) => {

        })

      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.orderInvoiceList();

      },



      statusChange(val) {

        _this.search_data.verify_status = val;

      },



      // 刷新按钮
      refresh() {
        this.$router.go(0);
      }

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }
</style>
